import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(e) { return { error: e }; }
  render() {
    if (this.state.error) {
      return (
        <div style={{ background: '#0A0A0B', color: '#C9C9CC', minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', fontFamily: 'monospace', padding: 40, gap: 16 }}>
          <div style={{ color: '#F6F6F7', fontSize: 11, letterSpacing: '0.25em', textTransform: 'uppercase' }}>GHXST · ERROR</div>
          <div style={{ fontSize: 13, color: '#818187', maxWidth: 600, textAlign: 'center', lineHeight: 1.6 }}>{this.state.error.message}</div>
          <div style={{ fontSize: 10, color: '#4A4A4E' }}>F12 → Console for full details</div>
          <button onClick={() => window.location.reload()} style={{ marginTop: 12, background: '#F5F5F6', border: 'none', borderRadius: 100, padding: '8px 22px', fontSize: 11, fontWeight: 700, color: '#0A0A0B', cursor: 'pointer', letterSpacing: '0.1em', fontFamily: 'monospace', boxShadow: '0 8px 24px rgba(0,0,0,0.5)' }}>RELOAD</button>
        </div>
      );
    }
    return this.props.children;
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<ErrorBoundary><App /></ErrorBoundary>);
